// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "dl:nth-child(even)>dd>p {\n  background-color: #eee;\n}\n", "",{"version":3,"sources":["custom.css"],"names":[],"mappings":"AAAA;EACI,sBAAsB;AAC1B","file":"custom.css","sourcesContent":["dl:nth-child(even)>dd>p {\n    background-color: #eee;\n}\n\n.bg-blue {\n    background-color: #1EBCFF;\n}\n"]}]);
// Exports
module.exports = exports;
